import isApiError from "@insite/client-framework/Common/isApiError";
import {
    createHandlerChainRunnerOptionalParameter,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { getTerms } from "@tKgpco/Services/TermsService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";
import { QuoteTermState } from "@tKgpco/Store/Data/Terms/TermsState";

type Parameters = HasOnSuccess & HasOnError;
type HandlerType = CustomApiHandler<Parameters, QuoteTermState>;

export const BeginLoadTerms: HandlerType = props => {
    props.dispatch({ type: "Custom/Terms/BeginLoad" });
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getTerms();
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
};

export const CompleteLoadTerms: HandlerType = props => {
    props.dispatch({
        type: "Custom/Terms/CompleteLoad",
        quoteTerms: props.apiResult,
    });
};

export const chain = [BeginLoadTerms, RequestDataFromApi, CompleteLoadTerms];

const loadAllTerms = createHandlerChainRunnerOptionalParameter(chain, {}, "CustomLoadTerms");
export default loadAllTerms;
